/**
 * Règles chiffrées de la création de personnage V5.
 * Les distributions se lisent { valeur: nombre de traits à cette valeur }.
 */

export const ATTRIBUTE_DISTRIBUTION = {4: 1, 3: 3, 2: 4, 1: 1};

export const SKILL_DISTRIBUTIONS = [
  {id: 'jackOfAllTrades', name: {fr: 'Touche-à-tout', en: 'Jack of All Trades'}, distribution: {3: 1, 2: 8, 1: 10}},
  {id: 'balanced', name: {fr: 'Équilibré', en: 'Balanced'}, distribution: {3: 3, 2: 5, 1: 7}},
  {id: 'specialist', name: {fr: 'Spécialiste', en: 'Specialist'}, distribution: {4: 1, 3: 3, 2: 3, 1: 3}},
];

export const SKILL_DISTRIBUTIONS_BY_ID = SKILL_DISTRIBUTIONS.reduce((acc, item) => ({...acc, [item.id]: item}), {});

/** Spécialités : celles obligatoires (Érudition, Artisanat, Représentation, Science) + 1 libre + celle du prédateur. */
export const FREE_SPECIALTIES = 1;

/** Disciplines de départ : 2 points dans une discipline de clan, 1 dans une autre (avant le bonus du prédateur). */
export const CREATION_DISCIPLINE_DOTS = [2, 1];

export const ADVANTAGE_POINTS = 7;
export const FLAW_POINTS = 2;
export const MIN_CONVICTIONS = 1;
export const MAX_CONVICTIONS = 3;
export const STARTING_HUMANITY = 7;

/** Catégories d'âge : générations possibles et Puissance du Sang de départ. */
export const AGE_CATEGORIES = [
  {id: 'childe', name: {fr: 'Infant', en: 'Childe'}, generations: [14, 15, 16], bloodPotency: 0},
  {id: 'neonate', name: {fr: 'Néonate', en: 'Neonate'}, generations: [12, 13], bloodPotency: 1},
  {id: 'ancilla', name: {fr: 'Ancilla', en: 'Ancilla'}, generations: [10, 11], bloodPotency: 2},
];

export const AGE_CATEGORIES_BY_ID = AGE_CATEGORIES.reduce((acc, item) => ({...acc, [item.id]: item}), {});
